import EfImg from '@elem/ui/ef-img';
import { FC } from 'react';
import css from './index.module.scss';
import EfEndorsements from 'elem/ui/ef-endorsements';
import EfMediaYoutube from 'elem/ui/ef-media-youtube';
import HearStories from '../../teaser/HearStories';

const TheComp: FC = () => {
    const media = {
        title: 'Explore TOP Youtube Reviews of Ecoflow DELTA Pro 3.',
        items: [
            {
                img: 'https://websiteoss.ecoflow.com/upload/image/1724126190182/Hobotech.jpg',
                title: 'EcoFlow Delta Pro 3 | 4000w 240v Split Phase Solar Generator Power Station',
                source: 'https://www.youtube.com/embed/qtPNj6XEbiE?si=zIdLDXBulwOqlvFa',
            },
            {
                img: 'https://websiteoss.ecoflow.com/upload/image/1724126190003/Lead%20Farmer%2073.jpg',
                title: 'EcoFlow Delta pro 3 The Best Portable Power Station',
                source: 'https://www.youtube.com/embed/ziCWyqi7nio?si=fmqLB92lXRNf6EMn',
            },
            {
                img: 'https://websiteoss.ecoflow.com/upload/image/1724133042007/life.jpg',
                title: 'EcoFlow DELTA Pro 3! Huge Improvements!',
                source: 'https://www.youtube.com/embed/n6vY9ywELXw?si=epS54_xJzlZqlXiG',
            },
            {
                img: 'https://websiteoss.ecoflow.com/upload/image/1724126189797/DIY%20Prepper%20TV.jpg',
                title: 'Power for Your Home AND Off-Grid: Ecoflow Delta Pro 3',
                source: 'https://www.youtube.com/embed/Op3fdzhn1nc?si=u9-FwKfmXMflbE-3',
            },
            {
                img: 'https://websiteoss.ecoflow.com/upload/image/1724126190614/Everyday%20Home%20Repairs%20(1).jpg',
                title: 'Ultimate Power Outage Backup | Power Your Entire House!',
                source: 'https://www.youtube.com/embed/LzFcdqZaSec?si=ZVax8NLCJ-nHc_Wm',
            },
            {
                img: 'https://websiteoss.ecoflow.com/upload/image/1724126190463/GreyMan%20Prepping.jpg',
                title: 'EcoFlow DELTA Pro 3 | Best Power Station In 2024?',
                source: 'https://www.youtube.com/embed/_zYHtNnuO-A?si=sTEedcfu_cIb8LRI',
            },
        ],
    };

    const endorsements = {
        title: 'Recognised In The Press',
        lists: [
            {
                logo: 'https://websiteoss.ecoflow.com/upload/image/1724133658862/USA%20Today%20(1).png',
                text: "The most powerful PPSs on the market now rival their gas counterparts.The upcoming launch of the EcoFlow DELTA Pro 3 this surmmer marks significant advancement in home backup power solutions,amplifying EcoFlow's already impressive lineup.",
            },
            {
                logo: 'https://websiteoss.ecoflow.com/upload/image/1724133658871/CNN%202.png',
                text: "The latest DELTA Pro 3, slated for a summer 2024 release, will further enhance these features, establishing it as the brand's flagship solution for energy independence and sustainability.",
            },
            {
                logo: 'https://websiteoss.ecoflow.com/upload/image/1724133658871/Good%20Housekeeping%20(1)%201.png',
                text: 'The combination of portability and quiet operation offers up almost infinite possibilities.',
            },
            {
                logo: 'https://websiteoss.ecoflow.com/upload/image/1724133658947/BobVila%201.png',
                text: "Its wide utility makes it one of the most versatile power stations available, and it's a great asset for any power-hungry DIYfer.",
            },
        ],
    };

    return (
        <div id="dp3-teaser-K" className={`${css['theComp']}`}>
            <HearStories />
            <div className="dp3-spec"></div>
            <EfMediaYoutube {...media} />
            <p className="memo">Note: The product shown is the US version; the Australian version may differ based on the final product.</p>
            <div className="dp3-spec"></div>
            <EfEndorsements {...endorsements} />
            <div className="dp3-spec"></div>
        </div>
    );
};

export default TheComp;
